import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { Pressable, View } from 'react-native';
import { Switch, Typography } from '@usepepper/sprout-kit-ui';

interface ToggleRowProps {
  caption?: string;
  checked: boolean;
  disabled?: boolean;
  onCheckedChange: (value: boolean) => void;
  title: string;
}

export const ToggleRow: React.FC<ToggleRowProps> = ({
  caption,
  checked,
  disabled,
  onCheckedChange,
  title,
}) => {
  const [styles] = useStyles();

  return (
    <Pressable
      accessibilityLabel={caption ? `${title}. ${caption}` : title}
      accessibilityRole="switch"
      aria-checked={checked}
      aria-disabled={!!disabled}
      disabled={disabled}
      onPress={() => onCheckedChange(!checked)}
      style={[styles.row, disabled ? styles.disabled : null]}
    >
      <View
        accessibilityElementsHidden
        importantForAccessibility="no"
        pointerEvents="none"
      >
        <Switch checked={checked} disabled={disabled} size="$28" />
      </View>
      <View style={styles.labels}>
        <Typography size="$sm" variant="label">
          {title}
        </Typography>
        {caption ? (
          <Typography muted size="$sm" variant="caption">
            {caption}
          </Typography>
        ) : null}
      </View>
    </Pressable>
  );
};

const useStyles = createStyles((theme) => ({
  disabled: {
    opacity: 0.5,
  },
  labels: {
    flex: 1,
  },
  row: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.sk.spacing.spaceSmall,
    justifyContent: 'flex-start',
    width: '100%',
  },
}));
